"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/no-unused-prop-types */
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var react_rainbow_components_1 = require("react-rainbow-components");
var useReduxForm_1 = __importDefault(require("react-rainbow-components/libs/hooks/useReduxForm"));
var debounce_1 = __importDefault(require("react-rainbow-components/libs/debounce"));
var airlinesLookup_1 = __importDefault(require("./airlinesLookup"));
var flightDetails_1 = __importDefault(require("./flightDetails"));
var styled_1 = require("./styled");
function FlightStatsInput(props) {
    var _a = useReduxForm_1.default(props), style = _a.style, className = _a.className, isLoading = _a.isLoading, airlines = _a.airlines, onChange = _a.onChange, onChangeDebounced = _a.onChangeDebounced, _b = _a.value, value = _b === void 0 ? {} : _b, required = _a.required, error = _a.error;
    var _c = value || {}, airline = _c.airline, _d = _c.flightNumber, flightNumber = _d === void 0 ? '' : _d, flightDetails = _c.flightDetails, date = _c.date;
    var hasInputsFilled = airline && flightNumber;
    var onChangeWithDebounce = react_1.useCallback(debounce_1.default(onChangeDebounced, 500), []);
    var fireChange = function (newValue) {
        onChange(newValue);
        onChangeWithDebounce({
            airline: newValue.airline,
            flightNumber: newValue.flightNumber,
        });
    };
    var handleChangeAirlne = function (airlineToSelect) {
        var newAirline = airlineToSelect && airlineToSelect.airline;
        fireChange(__assign(__assign({}, value), { airline: newAirline }));
    };
    var handleChangeFlightNumber = function (event) {
        var newFlightNumber = event.target.value;
        fireChange(__assign(__assign({}, value), { flightNumber: newFlightNumber }));
    };
    var updateFlightStatus = function () {
        onChange(value);
        onChangeDebounced({
            airline: value.airline,
            flightNumber: value.flightNumber,
        });
    };
    return (react_1.default.createElement(styled_1.StyledContainer, { className: className, style: style },
        react_1.default.createElement(styled_1.Row, null,
            react_1.default.createElement(airlinesLookup_1.default, { airlines: airlines, onChange: handleChangeAirlne, value: airline, required: required }),
            react_1.default.createElement(styled_1.StyledInput, { label: "Flight Number", required: required, labelAlignment: "left", placeholder: "Flight Number", onChange: handleChangeFlightNumber, value: flightNumber })),
        react_1.default.createElement(flightDetails_1.default, { data: flightDetails, date: date, flightNumber: flightNumber, isLoading: isLoading }),
        react_1.default.createElement(react_rainbow_components_1.RenderIf, { isTrue: hasInputsFilled && !isLoading },
            react_1.default.createElement(styled_1.StyledButton, { variant: "base", onClick: updateFlightStatus },
                react_1.default.createElement(styled_1.StyledUpdate, null),
                "Update Flight Status")),
        react_1.default.createElement(react_rainbow_components_1.RenderIf, { isTrue: error },
            react_1.default.createElement(styled_1.Error, null, error))));
}
exports.default = FlightStatsInput;
var DateType = prop_types_1.default.oneOfType([
    prop_types_1.default.instanceOf(Date),
    prop_types_1.default.string,
    prop_types_1.default.number,
]);
FlightStatsInput.propTypes = {
    /** The class name of the root element. */
    className: prop_types_1.default.string,
    /** It is an object with custom style applied to the root element. */
    style: prop_types_1.default.object,
    /** Loading state to indicate data is fetching. */
    isLoading: prop_types_1.default.bool,
    /** List with airlines to select. */
    airlines: prop_types_1.default.arrayOf(prop_types_1.default.shape({
        iata: prop_types_1.default.string,
        icao: prop_types_1.default.string,
        name: prop_types_1.default.string,
    })),
    /** The action trigged when some input value change. */
    onChange: prop_types_1.default.func,
    /** The action trigged with debounce when some input value change. */
    onChangeDebounced: prop_types_1.default.func,
    /** Specifies the value of the component. */
    value: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.shape({
            airline: prop_types_1.default.shape({
                iata: prop_types_1.default.string,
                icao: prop_types_1.default.string,
                name: prop_types_1.default.string,
            }),
            flightNumber: prop_types_1.default.string,
            flightDetails: prop_types_1.default.shape({
                updatedAt: DateType,
                departureAirport: prop_types_1.default.string,
                departureAirportTimezone: prop_types_1.default.string,
                departureTime: DateType,
                arrivalAirport: prop_types_1.default.string,
                arrivalAirportTimezone: prop_types_1.default.string,
                arrivalTime: DateType,
                direction: prop_types_1.default.string,
                status: prop_types_1.default.string,
            }),
            date: DateType,
        }),
    ]),
    /** Specifies that an input field must be filled out before submitting the form.
     * This value defaults to false. */
    required: prop_types_1.default.bool,
    /** Specifies that an input field must be filled out before submitting the form. */
    error: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.node]),
};
FlightStatsInput.defaultProps = {
    className: undefined,
    style: undefined,
    isLoading: false,
    airlines: [],
    onChange: function () { },
    onChangeDebounced: function () { },
    value: undefined,
    required: false,
    error: undefined,
};
//# sourceMappingURL=index.js.map